import type { Coding, Patient, Reference } from '@medplum/fhirtypes'
import { ExtendedObservation } from '@seen/core/models/observation'
import { useSearch } from '#src/hooks/useSearch.ts'

// The participant's most recent total for an instrument (its score
// Observation), with the band it was given in `interpretation`.
export function useLatestInstrumentTotal(
  participant: Reference<Patient> | undefined,
  totalCoding: Coding | undefined
) {
  const { data, isLoading } = useSearch(
    ExtendedObservation,
    participant?.reference && totalCoding?.code
      ? {
          patient: participant.reference,
          code: `${totalCoding.system ?? ''}|${totalCoding.code}`,
          'status:not': 'entered-in-error',
          _sort: '-date',
          _count: 1,
        }
      : undefined,
    { silentErrors: true }
  )
  return { total: data?.[0], isLoading }
}
